import React from 'react';
import IndustrialProcessesTable from '../components/IndustrialProcessesTable';

export function IndustrialProcesses() {
  return <IndustrialProcessesTable />;
}
